import { render, staticRenderFns } from "./AddAttendee.vue?vue&type=template&id=4e0cd65a&lang=pug&"
import script from "./AddAttendee.vue?vue&type=script&lang=js&"
export * from "./AddAttendee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports